const oldproject_data = payload => {
  return {
    type: "old_data",
    payload
  };
};

export default oldproject_data;
